import previewBannerComponentUrl from './previewBannerComponent.html';
import modalVideoUrl from './modal-video.html';
export default {
  templateUrl: previewBannerComponentUrl,
  bindings: {
    video: '<',
    image: '<',
    centered: '<?',
    feature: '@',
    buyCallback: '&?',
  },
  controllerAs: 'ctrl',
  transclude: true,
  controller: class PreviewBannerCtrl {
    constructor(Authentication, $sce, $uibModal) {
      'ngInject';

      Object.assign(this, { Authentication, $sce, $uibModal });
    }

    $onInit() {
      if (this.video) {
        this.videoTrusted = this.$sce.trustAsResourceUrl(`${this.video}`);
      }

      if (this.image) {
        this.imageTrusted = this.$sce.trustAsResourceUrl(this.image);
      }
    }

    openVideoModal() {
      const ctrl = this;
      this.$uibModal
        .open({
          templateUrl: modalVideoUrl,
          windowClass: 'sling-tour-modal sling-animate',
          size: '1020',
          controller() {
            this.videoSrc = ctrl.$sce.trustAsResourceUrl(`${ctrl.video}?autoplay=1`);
          },
          controllerAs: 'ctrl',
        })
        .result.ignoreCancel();
    }

    onBuyHandler() {
      this.buyCallback?.();
    }
  },
};
